(function () {
    'use strict';
    angular.module("EventListApp").controller('CultureCtrl', culture);

    culture.$inject = ['Constants', 'ApiFactory'];

    function culture(Constants, ApiFactory) {
        var vm = this;
        vm.Lang = [];
        vm.SelectedLang = 0;
        vm.eventId = 0;

        vm.init = function (eventID) {
            vm.eventId = eventID;
        }

        vm.setCulture = function (culture) {
            if (!culture)
                return false;

            ApiFactory.SetCulture(vm.eventId, culture)
                .then(function (response) {
                    if (response.data)
                        window.location.href = response.data;
                }).catch(function (data, status, headers, config) {
                    alert('error changing language')
                });
        }
    }
})();
